import { render, staticRenderFns } from "./KnowledgeGlossary.html?vue&type=template&id=0fd126e6&scoped=true&"
import script from "./KnowledgeGlossary.ts?vue&type=script&lang=ts&"
export * from "./KnowledgeGlossary.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/knowledge/_knowledge.scss?vue&type=style&index=0&id=0fd126e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd126e6",
  null
  
)

export default component.exports